import React, {useEffect, useRef, useState} from "react";
import styles from "./index.module.scss";
import {useQuery} from "react-query";
import jwtAxios from "../../../../auth/jwt-api";
import Apartment from "./Apartment";
import Parking from "./Parking";
import StorageRoom from "./StorageRoom";
import {useUrlSearchParams} from "use-url-search-params";
import Filters from "../../../../components/Filters/index";
import {clsx} from "clsx";
import ApratmentModel from "../../Schema/Models/ApratmentModel";
import {useNavigate} from "react-router-dom";
import translate from "../../../../i18n/translate";
import ParkingModel from "../../Schema/Models/ParkingModel";
import StorageModel from "../../Schema/Models/StorageModal";
import {useAuthDatas} from "../../../../auth/JWTAuthProvider";
import {useSelector} from "react-redux";

const floors = [5,4,3,2,1];
const officeFloors = [2,1,-1];
const parkingFloors = [1,2,3,4,5,6,7,8,9];
const storageRoomFloors = [-1];
const blocks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
const parkingBlocks = [1];
const storageRoomBlocks = [1, 2, 3,4];
const smokeAppartment=[]

export default function AllApartments() {
  const {userData} = useSelector(state => state.userData);
  const [smallChess, setSmallChess] = useState(false)
  const [propertyType, setPropertyType] = useState("apartment");
  const [excludeSmoke, setExcludeSmoke] = useState(false);
  const [showFavorites, setShowFavorites] = useState(false);
  const [searchParams, setSearchParams] = useUrlSearchParams({
    floor: 2,
    block: "all",
    minArea: 0,
    maxArea: 350,
    roomCount: "1+,2+,3+",
    saleRoomCount: "",
    status: undefined,
  });

  const navigate = useNavigate();
  const [isDragging, setIsDragging] = useState(false);
  const [scrollValues, setScrollValues] = useState({});
  const scrollContainer = useRef();
    const {

        isLoading:apartmentSyncLoading,
        refetch: refetchapartmentSync,
        isSuccess:syncApartmentSuccess
    } = useQuery(
        "all-apartments-sync",
        () =>
            jwtAxios.get("apartment/docs", {

            }),
        {
            enabled: false,
            retry: false,
            refetchOnWindowFocus: false,

        }
    );

    const {

        isLoading:parkingSyncLoading,
        refetch: refetchParkingSync,
        isSuccess:syncParkingSuccess

    } = useQuery(
        "all-parking-sync",
        () =>
            jwtAxios.get("parking/docs", {

            }),
        {
            enabled: false,
            retry: false,
            refetchOnWindowFocus: false,

        }
    );


    const {
    data,
    isLoading,
    refetch: refetchApartments,
  } = useQuery(
    "all-apartments",
    () =>
      jwtAxios.get("apartment", {
        params: {
          limit: 2000,
        },
      }),
    {
      enabled: propertyType === "apartment" || propertyType === "office",
      onSuccess(res) {
        const result = {};
        res?.data?.data?.results?.rows?.forEach((apartment) => {
          if (!result[apartment.floor]) {
            result[apartment.floor] = {};
            result[apartment.floor][apartment.block] = [];
          } else if (!result[apartment.floor][apartment.block]) {
            result[apartment.floor][apartment.block] = [];
          }
          result[apartment.floor][apartment.block].push(apartment);
        });
        res.data = result;
      },
    }
  );

  const {
    data: parkingData,
      refetch:refetchParking
  } = useQuery(
    "all-parking",
    () =>
      jwtAxios.get("parking", {
        params: {
          limit: 2000,
        },
      }),
    {
      enabled: propertyType === "parking",
      onSuccess(res) {
        const result = {};
        res?.data?.data?.results?.rows?.forEach((parking) => {
          const floor = parking.floor || 1;
          const block = 1;
          if (!result[floor]) {
            result[floor] = {};
            result[floor][block] = [];
          } else if (!result[floor][block]) {
            result[floor][block] = [];
          }
          result[floor][block].push(parking);
        });

        res.data = result;
      },
    }
  );

  const {
    data: storageRoomData,
      refetch:refetchStorage
  } = useQuery(
    "all-storage-rooms",
    () =>
      jwtAxios.get("storage-room", {
        params: {
          limit: 2000,
        },
      }),
    {
      enabled: propertyType === "storage-room",
      onSuccess(res) {
        const result = {};
        res?.data?.data?.results?.rows?.forEach((storageRoom) => {
          const floor = storageRoom.floor || -1;
          const block = storageRoom.block || 1;
          if (!result[floor]) {
            result[floor] = {};
            result[floor][block] = [];
          } else if (!result[floor][block]) {
            result[floor][block] = [];
          }
          result[floor][block].push(storageRoom);
        });

        res.data = result;
      },
    }
  );

    useEffect(() => {
        if (syncApartmentSuccess||syncParkingSuccess){
            refetchApartments()
            refetchParking()
        }
    }, [syncApartmentSuccess,syncParkingSuccess]);


  const syncSheets=()=>{
      refetchParkingSync()
      refetchapartmentSync()
  }

  const getApartmentData = () => {
    if (!data?.data) return { data: {} };
    const result = {};
    Object.keys(data.data).forEach((floor) => {
      Object.keys(data.data[floor]).forEach((block) => {
        const filtered = data.data[floor][block].filter((apt) => apt.type === "квартира");
        if (filtered.length > 0) {
          if (!result[floor]) result[floor] = {};
          result[floor][block] = filtered;
        }
      });
    });
    return { data: result };
  };

  const getOfficeData = () => {
    if (!data?.data) return { data: {} };
    const result = {};
    Object.keys(data.data).forEach((floor) => {
      Object.keys(data.data[floor]).forEach((block) => {
        const filtered = data.data[floor][block].filter((apt) => apt.type !== "квартира");
        if (filtered.length > 0) {
          if (!result[floor]) result[floor] = {};
          result[floor][block] = filtered;
        }
      });
    });
    return { data: result };
  };

  const currentData = propertyType === "apartment" ? getApartmentData() : propertyType === "office" ? getOfficeData() : propertyType === "parking" ? parkingData : storageRoomData;
  const currentBlocks = (propertyType === "apartment" || propertyType === "office") ? blocks : propertyType === "parking" ? parkingBlocks : storageRoomBlocks;
  const currentFloors = propertyType === "apartment" ? floors : propertyType === "parking" ? parkingFloors : propertyType==="office" ?officeFloors: storageRoomFloors;

  const isStorageRoom = propertyType === "storage-room";
  const columnItems = isStorageRoom ? currentFloors : currentBlocks;
  const rowItems = isStorageRoom ? currentBlocks : currentFloors;

  const getClass = (item) => {
    if (!item) {
      return [];
    }

    const order = item.orders?.[item.orders?.length - 1];
    const isSmoke = smokeAppartment.includes(Number(item.apartment_number));

    // Status filter
    const statusFilter = searchParams.status;
    let matchesStatus = true;
    if (statusFilter && statusFilter !== "all") {
        // If status filter is set, check if item matches
        if (statusFilter === "sold" || statusFilter === "reserved" || statusFilter === "reserved_paid" || statusFilter === "not_full_paid") {
            matchesStatus = order?.type === statusFilter;
        }
    }

    let isActive = false;
    if (propertyType==="apartment" || propertyType==="office"){
        isActive =
            +searchParams.minArea < item.m2 &&
            +searchParams.maxArea > item.m2 &&
            searchParams.roomCount?.split(",").length &&
            searchParams.roomCount
                .split(",")
                .includes(String(item?.additionalArea ? `${item.number}+`:item.number));

        // Exclude smoke apartments if filter is active
        if (excludeSmoke && !isSmoke) {
            isActive = false;
        }
    }else{
        isActive =
            +searchParams.minArea < item.m2 &&
            +searchParams.maxArea > item.m2
    }

    // Apply status filter to isActive
    if (!matchesStatus) {
        isActive = false;
    }

    // Apply favorites filter
    if (showFavorites && userData?.favorites) {
        if (!userData.favorites.includes(item.id)) {
            isActive = false;
        }
    }

    const isActiveSale = searchParams.saleRoomCount?.split(",").length &&
        searchParams.saleRoomCount
            .split(",")
            .includes(String(item?.additionalArea ? `${item.number}+`:item.number)) && order && true;

    return [styles[order?.type || "aviable"], styles[isActive ? "active" : ""], styles[isActiveSale ? "activeIsSale" : ""]];
  };




    return (
    <div className={styles.container}>
      <ApratmentModel
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        refetchApartments={refetchApartments}
      ></ApratmentModel>
        <ParkingModel
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            refetchParking={refetchParking}
        />
        <StorageModel
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            refetchStorage={refetchStorage}
        />
      <div
        className={styles.table}
        onMouseDown={(e) => {
          scrollContainer.current.classList.add("active"); // Add a class to indicate dragging
          setIsDragging(true);

          setScrollValues({
            startX: e.pageX - scrollContainer.current.offsetLeft,
            startY: e.pageY - scrollContainer.current.offsetTop,
            scrollLeft: scrollContainer.current.scrollLeft,
            scrollTop: scrollContainer.current.scrollTop,
          });
          scrollContainer.current.style.cursor = "grabbing";
        }}
        onMouseLeave={() => {
          setIsDragging(false);
          scrollContainer.current.style.cursor = "grab";
        }}
        onMouseUp={() => {
          setIsDragging(false);
          scrollContainer.current.style.cursor = "grab";
        }}
        onMouseMove={(e) => {
          if (!isDragging) return;

          e.preventDefault(); // Prevent text selection

          // Calculate the distance moved in X and Y directions
          const x = e.pageX - scrollContainer.current.offsetLeft;
          const y = e.pageY - scrollContainer.current.offsetTop;

          const walkX = (x - scrollValues.startX) * 2; // Multiply for faster scrolling (X-axis)
          const walkY = (y - scrollValues.startY) * 2; // Multiply for faster scrolling (Y-axis)

          scrollContainer.current.scrollLeft = scrollValues.scrollLeft - walkX;
          scrollContainer.current.scrollTop = scrollValues.scrollTop - walkY;
        }}
        ref={scrollContainer}
      >
        <table className={clsx("custom-table")}>
          <tr>
            <th>
              {" "}
              <p
                style={{
                  textAlign: "end",
                }}
              >
                  {
                      propertyType === "parking" ? "№" :
                      isStorageRoom ? translate("menu.floors") :
                      translate("misc.blocks")
                  }

              </p>
                {
                    propertyType === "parking" ? "" :
                    isStorageRoom ? translate("misc.blocks") :
                    translate("menu.floors")
                }
            </th>
            {columnItems.map((col) => (

              <th key={col}>
                  {
                      propertyType === "parking" ? "" :
                      isStorageRoom ? <span>{col} - {translate("filter.floor_suffix")}</span> :
                      <span>{col} - {translate("apartment.block")}</span>
                  }

              </th>
            ))}
          </tr>
          {rowItems.map((row) => {
            const getFloorAndBlock = (col) => isStorageRoom ? { floor: col, block: row } : { floor: row, block: col };
            return (
            <tr key={row}>
              <th className={styles.floor} onClick={() => !isStorageRoom ? navigate(`/main/schema?floor=${row}`) : undefined}>
                  {propertyType === "parking" ? <span>{row}</span> :
                   isStorageRoom ? <span>{row} - {translate("apartment.block")}</span> :
                   <span>{row} - {translate("filter.floor_suffix")}</span>}

              </th>
              {columnItems.map((col) => {
                const { floor, block } = getFloorAndBlock(col);
                return (
                <td key={col}>
                  <div className={styles["apartments-section"]}>
                    {propertyType === "apartment" || propertyType === "office" ? (
                      currentData?.data[floor]?.[block]?.sort((a, b) => (block === 3 || block === 4) ? Number(a.apartment_number) - Number(b.apartment_number) : Number(b.apartment_number) - Number(a.apartment_number))?.map((apartment) => (
                        <Apartment
                          key={apartment?.id}
                          smallChess={smallChess}
                          apartment={apartment}
                          onApartmentClick={() => {
                            setSearchParams({
                              ...searchParams,
                              apartmentId: apartment.id,
                            });
                          }}
                          classNames={getClass(apartment)}
                          isSmoke={propertyType === "apartment" && smokeAppartment.includes(Number(apartment.apartment_number))}
                          disabled={block === 1}
                        />
                      ))
                    ) : propertyType === "parking" ? (
                      currentData?.data[floor]?.[block]?.map((parking) => (
                        <Parking
                          key={parking?.id}
                          smallChess={smallChess}
                          parking={parking}
                          onParkingClick={() => {
                            setSearchParams({
                              ...searchParams,
                              parkingId: parking.id,
                            });
                          }}
                          classNames={getClass(parking)}
                        />
                      ))
                    ) : (
                      currentData?.data[floor]?.[block]?.map((storageRoom) => (
                        <StorageRoom
                          key={storageRoom?.id}
                          smallChess={smallChess}
                          storageRoom={storageRoom}
                          onStorageRoomClick={() => {
                            setSearchParams({
                              ...searchParams,
                              storageId: storageRoom.id,
                            });
                          }}
                          classNames={getClass(storageRoom)}
                        />
                      ))
                    )}
                  </div>
                </td>
                );
              })}
            </tr>
            );
          })}
        </table>
      </div>
      <Filters
          smallChess={smallChess}
          setSmallChess={setSmallChess}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          filterType={"all"}
          propertyType={propertyType}
          setPropertyType={setPropertyType}
          syncSheets={syncSheets}
          excludeSmoke={excludeSmoke}
          setExcludeSmoke={setExcludeSmoke}
          showFavorites={showFavorites}
          setShowFavorites={setShowFavorites}
          userData={userData}
      ></Filters>
    </div>
  );
}
